// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Cars__CarController from "./cars/car_controller"
application.register("cars--car", Cars__CarController)

import Cars__GalleryController from "./cars/gallery_controller"
application.register("cars--gallery", Cars__GalleryController)

import Cars__MenuController from "./cars/menu_controller"
application.register("cars--menu", Cars__MenuController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import Admin__SortableController from "./admin/sortable_controller"
application.register("admin--sortable", Admin__SortableController)
